import { createReducer, on } from '@ngrx/store';
import { actionCountriesListGetSuccess } from './countries.actions';

export interface CountriesState {
  countriesList: object;
}

const initialState: CountriesState = {
  countriesList: {},
};

export const countriesReducer = createReducer(
  initialState,
  on(actionCountriesListGetSuccess, (state, action) => {
    return {
      countriesList: action.payload.countriesList,
    };
  })
);
